import React, { HTMLAttributes, useCallback, useRef } from "react";
// import { observer } from "mobx-react-lite";
import { Hooks, Util } from "@xt/xtbase";
// const { XtContext } = Context;
const { useTranslation } = Hooks;
const { Big } = Util;
// import store from "store";

import { Slider } from "antd";

import styles from "./index.module.scss";

import { OptionDepthProps } from "../../index";
interface Props extends HTMLAttributes<HTMLDivElement> {
  option: OptionDepthProps;
  setOption: (arg: OptionDepthProps) => void;
}

const Main: React.FC<Props> = ({ option, setOption }) => {
  const t = useTranslation();
  const lastVibrateAtRef = useRef(0);

  const tooltipFormatter = useCallback((value) => {
    return Big(value).times(100).toFixed() + "%";
  }, []);

  const triggerVibrate = useCallback(() => {
    if (typeof window === "undefined") return;
    const { navigator } = window;
    if (!navigator || typeof navigator.vibrate !== "function") return;
    const now = Date.now();
    if (now - lastVibrateAtRef.current < 80) return;
    lastVibrateAtRef.current = now;
    navigator.vibrate(10);
  }, []);

  const handleChange = useCallback((value) => {
    triggerVibrate();
    setOption({ scope: value });
  }, [setOption, triggerVibrate]);

  return (
    <div className={styles.main}>
      <span>{t("trade.scope")}:</span>
      <Slider value={option.scope} max={0.2} min={0.01} step={0.01} tooltip={{ formatter: tooltipFormatter }} onChange={handleChange} />
    </div>
  );
};

// export default observer(Main);
export default Main;
